<template>
  <li class="dropdown user user-menu">
    <a href="#" class="dropdown-toggle" data-toggle="dropdown">
      <!-- The user image in the navbar-->
      <img src="/static/img/pro1.jpg" class="user-image"/>
      <!-- <span class="hidden-xs" style="color: #3c8dbc">.</span> -->
    </a>
    <!-- Account Info and Menu -->
    <ul class="dropdown-menu">
      <li class="user-footer">
        <router-link to="/admin/profile">
          <span>Profile</span>
        </router-link>
      </li>
      <li class="user-footer">
        <router-link @click.native="logOutAdmin" to="/">
          <span>Logout</span>
        </router-link>
      </li>
    </ul>
  </li>
</template>

<script>

  import Vue from 'vue'

  export default {
    name: 'UserMenu',
    methods: {
      logOutAdmin() {
        Vue.auth.destroyToken()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// UserMenu.vue?2bc88ba0